module.exports = __webpack_public_path__ + "img/ring_g_skip_0_null@3x.5686ea8c.png";